const ASSETS = "https://customer-assets-lqy194kg.emergentagent.net/job_axis-health-tech/artifacts";

export const SYNIR_MEDIA = {
  loop: `${ASSETS}/06068be2a67e97ba_synir-video-1080x1920%20%284%29.mp4`,
  full: `${ASSETS}/eea10537bf149b66_synir-edit-dirty-harry-lento-com-musica-CONFERIR.mp4`,
  poster: `${ASSETS}/0dcd125d22b2f6c0_synir-post-1080x1350.png`,
};

export const SYNIR_STATS = [
  { value: 455, label: "contas auditadas em um único dia" },
  { value: 289, label: "fechadas e protocoladas" },
  { value: 7, label: "não faturáveis no protocolo próprio" },
  { value: 150, label: "com pendência enviada ao setor certo" },
];

export const SYNIR_PILLARS = [
  {
    id: "auditoria",
    title: "Auditoria",
    icon: "ScanSearch",
    items: [
      "Cada conta é lida por inteiro: evoluções médicas e de enfermagem, laudos de laboratório, imagem e ECG, autorizações, assinaturas da guia e o relato de cada material usado.",
      "Sem ninguém precisar abrir conta por conta.",
    ],
  },
  {
    id: "correcoes",
    title: "Correções seguras, antes de fechar",
    icon: "Wrench",
    items: [
      "Guia da conta gravada como \"PENDENTE\" ou com sujeira é trocada pela guia correta da Entrada Única.",
      "Itens sem guia recebem a guia da conta; senha preenchida onde a regra do convênio permite.",
      "Materiais lançados com a data fora do atendimento têm a data acertada pela própria data de atendimento.",
      "Tudo registrado em log, para auditoria e conferência.",
    ],
  },
  {
    id: "pendencias",
    title: "Pendências com endereço certo",
    icon: "Send",
    items: [
      "Enfermagem, laboratório, imagem, recepção e equipe médica recebem só o que é delas, com a explicação do que falta.",
      "Evolução feita e não liberada vira aviso para liberar, e não cobrança de evolução ausente.",
      "Quando a área resolve, a pendência fecha sozinha no TASY. O que o faturamento já liberou não volta.",
    ],
  },
  {
    id: "fechamento",
    title: "Fechamento e protocolo",
    icon: "Stamp",
    items: [
      "Diagnóstico de recusa: quando o TASY devolve uma lista de 25 códigos, o SYNIR mostra a única crítica que impede o fechamento e o item exato a corrigir.",
      "Regras por convênio: autorização só quando a operadora exige, contas somente de consulta da ortopedia e da pediatria como não faturáveis, taxa de observação só quando há outro item na conta.",
      "Protocolo no mês certo pela data de corte de cada convênio, com a pediatria em protocolo próprio.",
      "Relatórios conta a conta: faturadas, não faturáveis, sem guia e reabertas.",
    ],
  },
];
